"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.StackWrapper = exports.StyledColumn = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system");

var _rebass = require("rebass");

var StyledColumn = (0, _styled.default)(_rebass.Box)((0, _styledSystem.system)({
  width: {
    property: 'width',
    transform: function transform(value, scale) {
      return value !== null ? "".concat(scale[value] * 100, "%") : null;
    },
    defaultScale: [0, 1 / 12, 2 / 12, 3 / 12, 4 / 12, 5 / 12, 6 / 12, 7 / 12, 8 / 12, 9 / 12, 10 / 12, 11 / 12, 12 / 12]
  }
}));
exports.StyledColumn = StyledColumn;
var StackWrapper = (0, _styled.default)('div')(function (_ref) {
  var margin = _ref.theme.space,
      space = _ref.space;
  return {
    '> *': {
      marginTop: "".concat(margin[space], " !important"),
      '&:last-of-type': {
        marginBottom: "".concat(margin[space], " !important")
      }
    }
  };
});
exports.StackWrapper = StackWrapper;